(function() {
  'use strict';

  const NEW_COVERAGE_ITEMS = [
    'Mechanical failures',
    'Power failures (won’t power-on)',
    'Cracked Screens',
    'Breakdowns during normal use'
  ];

  function updateCoverageIncludes() {
    const coverageList = document.querySelector('.umbrella-modal-coverage .umbrella-modal-list');
    
    if (coverageList && !coverageList.dataset.updated) {
      coverageList.innerHTML = '';
      
      NEW_COVERAGE_ITEMS.forEach(function(item) {
        const listItem = document.createElement('li');
        listItem.className = 'umbrella-modal-list-item';
        listItem.textContent = item;
        coverageList.appendChild(listItem);
      });
      
      coverageList.dataset.updated = 'true';
    }
  }

  function addCoverageIntro() {
    const coverageSection = document.querySelector('.umbrella-modal-coverage');
    
    if (coverageSection) {
      const title = coverageSection.querySelector('.umbrella-modal-section-title');
      let introText = coverageSection.querySelector('.umbrella-coverage-intro');
      
      if (title) {
        title.textContent = 'Get award-winning support that goes above and beyond';
      }
      
      if (!introText) {
        introText = document.createElement('p');
        introText.className = 'umbrella-coverage-intro';
        introText.style.cssText = 'margin-bottom: 12px; color: #324354; font-size: 14px; line-height: 1.5;';
        introText.textContent = 'Coverage Includes:';
        
        if (title && title.nextSibling) {
          coverageSection.insertBefore(introText, title.nextSibling);
        } else if (title) {
          title.parentNode.insertBefore(introText, title.nextSibling);
        }
      } else {
        introText.textContent = 'Coverage Includes:';
      }
      
      if (!coverageSection.dataset.introAdded) {
        coverageSection.dataset.introAdded = 'true';
      }
    }
  }

  function replaceProductImage() {
    const modal = document.querySelector('.umbrella-modal-dialog, .umbrella-modal-container, dialog[open].umbrella-modal-dialog');
    if (!modal) {
      return;
    }
    
    const productImages = modal.querySelectorAll('.umbrella-modal-image-section img, .umbrella-modal-image, .umbrella-product-image');
    
    const shieldImagePath = window.SHOPIFY_SHIELD_SVG_URL || '/assets/shield.svg';
    
    productImages.forEach(function(img) {
      if (img && !img.classList.contains('umbrella-modal-logo-image')) {
        const currentSrc = (img.src || img.getAttribute('src') || '').toLowerCase();
        const isShield = currentSrc.includes('shield.svg') || currentSrc.includes('shield');
        
        if (!isShield) {
          img.src = shieldImagePath;
          img.alt = img.alt || 'SIMO Shield';
          img.dataset.replaced = 'true';
          
          img.style.objectFit = 'contain';
          img.style.display = 'block';
          img.style.maxWidth = '350px';
          img.style.minWidth = '150px';
          img.style.width = 'auto';
          img.style.height = 'auto';
        }
      }
    });
  }

  function relocateInfoIcon() {
    if (!document.body.classList.contains('template-cart')) {
      return;
    }
    document.querySelectorAll('.umbrella-options').forEach(function(options) {
      const title = options.querySelector('.umbrella-options-title');
      const widget = options.closest('.umbrella-inline-style, .umbrella-warranty-widget');
      const btn = widget && widget.querySelector('.umbrella-warranty-modal-btn');
      if (title && btn && btn.parentElement !== title) {
        title.insertBefore(btn, title.firstChild);
      }
    });
  }

  function updateModalContent() {
    updateCoverageIncludes();
    addCoverageIntro();
    replaceProductImage();
  }

  function setupModalTriggerListeners() {
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-umbrella-modal-trigger]');
      if (trigger) {
        setTimeout(function() {
          replaceProductImage();
          updateModalContent();
        }, 100);
        setTimeout(function() {
          replaceProductImage();
          updateModalContent();
        }, 500);
        setTimeout(function() {
          replaceProductImage();
          updateModalContent();
        }, 1000);
      }
    });
  }

  function watchForModal() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          
          if (mutation.attributeName === 'class') {
            if (target.classList.contains('umbrella-modal-visible') || 
                target.classList.contains('umbrella-modal-dialog') ||
                target.classList.contains('umbrella-modal-container')) {
              updateModalContent();
            }
          }
          
          if (mutation.attributeName === 'open' && target.tagName === 'DIALOG') {
            if (target.hasAttribute('open') && target.classList.contains('umbrella-modal-dialog')) {
              setTimeout(function() {
                replaceProductImage();
                updateModalContent();
              }, 50);
              setTimeout(function() {
                replaceProductImage();
                updateModalContent();
              }, 200);
              setTimeout(function() {
                replaceProductImage();
                updateModalContent();
              }, 500);
            }
          }
          
          if (mutation.attributeName === 'src' && target.tagName === 'IMG') {
            if (target.closest && target.closest('.umbrella-modal-dialog, .umbrella-modal-container')) {
              if (target.classList.contains('umbrella-modal-image') || 
                  target.classList.contains('umbrella-product-image') ||
                  target.closest('.umbrella-modal-image-section')) {
                if (!target.classList.contains('umbrella-modal-logo-image')) {
                  replaceProductImage();
                }
              }
            }
          }
        }
        
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.querySelector && node.querySelector('.umbrella-options-title')) {
                relocateInfoIcon();
              }
              if (node.tagName === 'DIALOG' && node.classList && node.classList.contains('umbrella-modal-dialog')) {
                setTimeout(function() {
                  replaceProductImage();
                  updateModalContent();
                }, 50);
                setTimeout(function() {
                  replaceProductImage();
                  updateModalContent();
                }, 200);
                setTimeout(function() {
                  replaceProductImage();
                  updateModalContent();
                }, 500);
              }
              
              if (node.classList && (node.classList.contains('umbrella-modal-dialog') || 
                  node.classList.contains('umbrella-modal-container'))) {
                updateModalContent();
              }
              if (node.classList && (node.classList.contains('umbrella-modal-dialog') || 
                  node.classList.contains('umbrella-modal-container') ||
                  node.closest && node.closest('.umbrella-modal-dialog, .umbrella-modal-container'))) {
                const images = node.querySelectorAll ? node.querySelectorAll('.umbrella-modal-image-section img, .umbrella-modal-image, .umbrella-product-image') : [];
                if (images.length > 0) {
                  replaceProductImage();
                }
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'src', 'open']
    });

    setInterval(function() {
      const modal = document.querySelector('.umbrella-modal-dialog.umbrella-modal-visible, .umbrella-modal-container');
      const dialog = document.querySelector('dialog[open].umbrella-modal-dialog');
      if (modal || dialog) {
        replaceProductImage();
      }
    }, 50);
  }

  setupModalTriggerListeners();
  watchForModal();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateModalContent();
      relocateInfoIcon();
    });
  } else {
    updateModalContent();
    relocateInfoIcon();
  }

})();
